var OutcomesCounter = class extends HTMLElement {
  constructor() {
    super();

    this.hasRun = false;
    this.counters = this.querySelectorAll('.count');

    this.init();
  }

  init() {
    window.addEventListener('scroll', event => {
      if (window.scrollY > (this.offsetTop - (window.innerHeight + 200))) {
        if (!this.hasRun) {
          this.initCounters();
        }
      }
    });
  }

  initCounters() {
    this.counters.forEach(counter => {
      const number = Number(counter.dataset.number);
      const delay = Number(counter.dataset.delay) || 0;
    
      setTimeout(() => {
        let currentNumber = 1;
        setInterval(() => {
          if (currentNumber <= number) {
            counter.innerHTML = currentNumber;
            currentNumber++;
          }
        }, 20);
      }, delay);
    });  

    this.hasRun = true;
  }
}

customElements.define('outcomes-counter', OutcomesCounter);